<template>
  <v-container fluid grid-list-md>
    <v-layout row wrap>
      <v-flex v-for="sensor in get_sensors" :key="sensor.deviceId" xs12 md3>
        <v-card height="400px">
          <v-card-title primary-title :class="['sensor-type-' + sensor.TypeCode]">
            <table>
              <tr>
                <td>
                  <h4 style="padding-right: 10px">{{sensor.Name}}</h4>
                </td>
                <td style="font-size: x-small">
                  Sensor type: {{sensor.TypeName}}
                  <br>
                  Device Id: {{sensor.deviceId}}
                </td>
              </tr>
            </table>
          </v-card-title>
          <v-divider></v-divider>
          <div style="padding: 10px;">
            <!-- <transition-group name="sensors" tag="p">
              <span v-for="k in Object.keys(sensor)" :key="k">
                <template v-if="k != 'timestamp' && k != '_id'">
                  <p>
                    {{k}}:&nbsp;
                    <span class="sensor-value">{{sensor[k]}}</span>
                  </p>
                </template>
              </span>
            </transition-group>
            <v-divider></v-divider>-->

            <div v-for="reading in get_sensorReadings" :key="reading.deviceId">
              <span v-if="reading.deviceId == sensor.deviceId">
                <transition-group name="reading">
                  <p v-for="r in Object.keys(reading)" :key="r">
                    <template
                      v-if="r != '_id' && r != 'payloadNum' && r != '__v' && r != 'sensorName' && r != 'deviceId' && r != 'sensorType'"
                    >
                      <template v-if="r == 'timestamp'">
                        {{r}}:&nbsp;
                        {{reading[r] | moment("MM-DD-YYYY h:mm:ss a")}}
                      </template>
                      <template v-else>
                        {{r}}:&nbsp;
                        {{reading[r]}}
                      </template>
                    </template>
                  </p>
                </transition-group>
              </span>
            </div>
          </div>
        </v-card>
      </v-flex>
      <SocketLog/>
    </v-layout>
  </v-container>
</template>



<script>
import WeatherService from "@/services/WeatherService";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},

  computed: {
    ...mapGetters(["get_sensorReadings", "get_sensors"])
  }
};
</script>

<style>
@keyframes pulse {
  0% {
    background-color: none;
  }
  50% {
    background-color: rgba(251, 255, 6, 0.2);
  }
  100% {
    background-color: none;
  }
}
.sensor-value,
.sensor-value {
  transition: all 1s;
}
.sensor-value-enter, .sensor-value-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  animation: fadein;
}

.sensor-type-1 {
  background-color: #e91e63 !important;
}
.sensor-type-2 {
  background-color: #2196f3 !important;
}
.sensor-type-3 {
  background-color: #8bc34a !important;
}
.sensor-type-text-TMP36 {
  color: #e91e63 !important;
}
.sensor-type-text-DHT22 {
  color: #2196f3 !important;
}
.sensor-type-text-BMP180 {
  color: #8bc34a !important;
}
.reading-enter-active {
  transition: all 1s;
  animation: pulse 1s;
}

.reading-leave-active {
  transition: all 0.5s;
  transform: translateY(-30px);
}
</style>
